export const CATEGORIES_LIST_ITEM = "CATEGORIES_LIST_ITEM";
export const GET_PRODUCTS_BY_CATEGORY_ID = "GET_PRODUCTS_BY_CATEGORY_ID";
export const GET_CATEGORIES_FOR_FRONTEND = "GET_CATEGORIES_FOR_FRONTEND"